import { API_ROUTE_ADMIN_ASSETS_NEW } from '@/resources/api-routes'
import { update } from '@/util/auth'

const IS_NEW_BACKEND_API = true
export async function activateAsset(id: number) {
  return update(`${API_ROUTE_ADMIN_ASSETS_NEW}/${id}/activate`, undefined, IS_NEW_BACKEND_API)
}
